export default __webpack_public_path__ + "static/smu_1-1abedd6142e032ea9d6205ae2deaa4aa.jpg";